<template>
    <a
        v-if="title"
        class="c-article flex items-center border-b border-gray-200"
        :href="href"
        target="_blank"
    >
        <div class="pl-12 py-8 pr-4 w-3/4">
          <span v-if="section" class="text-blue-200 font-benton font-semibold uppercase w-full mb-2">
              {{ section }}
          </span>
          <h3>{{ title }}</h3>
        </div>
        <figure class="w-1/4 c-image c-image--square">
          <img class="h-full" v-if="imageSrc" :src="imageSrc" :alt="title">
        </figure>
    </a>
</template>

<script>
    export default {
      name: 'PuzzleArticleListItem',

      props: ['href', 'opengraphData'],

      data () {
        return {
          title: null,
          imageSrc: null,
          section: null
          // title: `Slachtoffer zuurgooier: 'Probeer verleden achter me te laten'`,
          // imageSrc: 'https://static.standaard.be/Assets/Images_Upload/2016/10/14/zuurgooier_mh.jpg'
        }
      },

      methods: {
        async setOpengraphData () {
          let opengraphObject = null

          if (this.opengraphData) {
            opengraphObject = JSON.parse(this.opengraphData)
          } else if (this.href) {
            await this.$store.dispatch('openGraphData', { href: this.href })
              .then((result) => {
                opengraphObject = result.openGraph
              })
          }

          if (!opengraphObject) {
            return
          }

          this.title = opengraphObject.title
          this.imageSrc = opengraphObject.image ? opengraphObject.image.url : null
          this.section = opengraphObject.articleSection
        }
      },

      watch: {
        opengraphData: {
          handler: 'setOpengraphData',
          immediate: true
        }
      }
    }
</script>